import { ActGlo, ActMes } from '../App_Data/ActionTypes';

const DateNow = new Date();
const DateDeb = new Date(DateNow.getFullYear() - 1, DateNow.getMonth(), DateNow.getDate());

const initialState = {
    Messages: ActGlo.EN_COURS_DE_CHARGEMENT,
    DateDeb,
    // Prestations : [],
};

function MesStore(state = initialState, action) {
    switch (action.type) {
    case ActGlo.RESET_STORE:
    case ActGlo.CHANGE_COP_SEL:
        return initialState;
    case ActMes.MES_AJOUT:
        return {
            ...state,
            Messages: action.data,
        };
    case ActMes.MES_DATE_DEBUT:
        return {
            ...state,
            DateDeb: action.data,
        };
    case ActMes.MES_MARQUER_VU_PAR_CLIENT:
        return {
            ...state,
            Messages: state.Messages.map(message => (message.NumAuto === action.data ? { ...message, VuParClient: 100 } : message)),
        };
    case ActMes.MES_CHARGE_PRESTATIONS:
        return {
            ...state,
            Prestations: action.data,
        };
    default:
        return state;
    }
}

export default MesStore;



// WEBPACK FOOTER //
// ./src/Reducers/MesStore.js